export function isClientBasedAuth(auth) {
  return !!auth.clientId;
}
export function isAsapBasedAuth(auth) {
  return !!auth.asapIssuer;
}
export const authToOwner = auth => {
  if (isAsapBasedAuth(auth)) {
    return auth;
  }

  const clientAuth = {
    id: auth.clientId,
    baseUrl: auth.baseUrl,
    token: auth.token
  };
  return clientAuth;
};